import React from "react";
import PropTypes from "prop-types";
import { makeStyles, Typography } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold",
    color: "#1E6594",
    //.palette.text.secondary,
  },
}));

/**
 * Title General pop Up
 * @returns {React}
 */
export const TitleGeneralPopUp = ({ children, variant }) => {
  const classes = styles();
  return (
    <Typography variant={variant} className={classes.title}>
      {children}
    </Typography>
  );
};

TitleGeneralPopUp.propTypes = {
  /**
   * Inheritance of the text that the component contains
   */
  children: PropTypes.node,
  /**
   * Variant typography
   */
  variant: PropTypes.string,
};
